var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", { staticClass: "headingLevel mb-4" }, [
          _c("div", { staticClass: "custom-control custom-checkbox mb-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.leaseOptions.showPerpetualUpgrade,
                  expression: "leaseOptions.showPerpetualUpgrade",
                },
              ],
              staticClass: "custom-control-input",
              attrs: {
                type: "checkbox",
                id: "show_date_perpetual_" + _vm.product.id,
              },
              domProps: {
                checked: Array.isArray(_vm.leaseOptions.showPerpetualUpgrade)
                  ? _vm._i(_vm.leaseOptions.showPerpetualUpgrade, null) > -1
                  : _vm.leaseOptions.showPerpetualUpgrade,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.leaseOptions.showPerpetualUpgrade,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.leaseOptions,
                            "showPerpetualUpgrade",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.leaseOptions,
                            "showPerpetualUpgrade",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.leaseOptions, "showPerpetualUpgrade", $$c)
                    }
                  },
                  function ($event) {
                    return _vm.updateLeaseOptions($event)
                  },
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "custom-control-label d-flex flex-wrap",
                staticStyle: {
                  "font-size": "inherit",
                  "font-weight": "inherit",
                },
                attrs: { for: "show_date_perpetual_" + _vm.product.id },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.getTranslation(
                        "licence-configurator",
                        "upgrade_to_perpetual"
                      )
                    ) +
                    "\n                "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class:
            _vm.leaseOptions.showPerpetualUpgrade === true ? "mb-4" : "d-none",
        },
        [
          _vm._l(_vm.filteredPrograms, function (program) {
            return _c("div", { key: program.id, staticClass: "col-12  " }, [
              _c("div", { staticClass: "pl-5" }, [
                _c(
                  "div",
                  { staticClass: "custom-checkbox b-custom-control-lg mb-4 " },
                  [
                    _c("span", { staticStyle: { "font-weight": "400" } }, [
                      _vm._v(
                        _vm._s(_vm.getProgramName(program.id, _vm.product.id))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("b", { staticStyle: { "font-weight": "700" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.priceFormat(
                            _vm.getProgramPrice(
                              program.id,
                              "",
                              "cloud_time_quantity",
                              program.product,
                              program.cloud_time_quantity * 3
                            )
                          )
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.datesWithPerpetualUpgrade, function (date) {
            return _c("div", { key: date, staticClass: "col-12  " }, [
              _c("div", { staticClass: "pl-5" }, [
                _c(
                  "div",
                  { staticClass: " custom-checkbox b-custom-control-lg mb-4 " },
                  [
                    _c("span", { staticStyle: { "font-weight": "400" } }, [
                      _vm._v(
                        _vm._s(_vm.formatDateByLang(date)) +
                          " " +
                          _vm._s(_vm.getProgramText(date))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("b", { staticStyle: { "font-weight": "700" } }, [
                      _vm._v(_vm._s(_vm.priceFormat(_vm.getDatePrice(date)))),
                    ]),
                  ]
                ),
              ]),
            ])
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }